import { Component, OnInit } from '@angular/core';
import { PlayerDataService } from '../../services/player-data.service';
import { UtilsService } from '../../services/utils.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'mktg-decisions',
  standalone: true,
  imports: [
    CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule,
  ],
  templateUrl: './mktg-decisions.component.html',
  styleUrl: './mktg-decisions.component.css'
})
export class MktgDecisionsComponent implements OnInit {

  marketingD: any = null;
  RO: any = null;
  channels: string[] = [];

  // Map to store words for each spend cell
  spendWords: { [key: string]: string } = {};

  constructor(
    private playerData: PlayerDataService,
    private utils: UtilsService
  ) { }

  async ngOnInit() {
    debugger;
    const cached = await this.playerData.getPageDecisionData('marketing');
    if (typeof cached === 'string') {
      this.marketingD = JSON.parse(cached);
    } else if (cached) {
      this.marketingD = cached;
    } else {
      this.marketingD = {
        NumberofServiceCenters: 0,
        NumberofSalesOutlets: 0,
        MarketResearch: 'N',
        DataOnCompetition: 'N',
        brandPromotion: []
      };
    }
    console.log("MarketingD read");
    console.log(this.marketingD);
    const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    this.RO = roCached;
    console.log(this.RO);
    this.channels = this.RO.channels;
  }

  toggleYN(field: 'MarketResearch' | 'DataOnCompetition') {
    this.marketingD[field] = (this.marketingD[field] === 'Y') ? 'N' : 'Y';
    this.save();
  }
   toggleMarketPerceptionYN(brand: any) {
    brand.MarketPerceptionReport= (brand.MarketPerceptionReport === 'Y') ? 'N' : 'Y';
    this.save();
  }

  save() {
    console.log("before");
    console.log(this.marketingD);
    this.playerData.setPageDecisionData('marketing', this.marketingD);
    console.log("after");
    console.log(this.marketingD);
  }

  onValueChange() {
    this.save();
  }

  onSpendChange(brand: any, ch: string) {
    console.log("spend change");
    console.log(brand);
    console.log(ch);
    
    const val = Number(brand.spend[ch] || 0);
    
    const key = this._spendKey(brand, ch);
    this.spendWords[key] = this.utils.numberToWords(val);
    this.save();
  }

  getSpendWords(brand: any, ch: string): string {
    const key = this._spendKey(brand, ch);
    return this.spendWords[key] || '';
  }

  private _spendKey(brand: any, ch: string): string {
    return `${brand.productId}_${ch}`;
  }
}
